import { render, staticRenderFns } from "./PostPhotos.vue?vue&type=template&id=14bd9406&"
import script from "./PostPhotos.vue?vue&type=script&lang=js&"
export * from "./PostPhotos.vue?vue&type=script&lang=js&"
import style0 from "./PostPhotos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports